/**
 * The browser client entry (the static-deploy / Pages bundle). Vite builds this
 * into a single ESM file (`/testui.js`) that the page shell imports to boot the
 * live harness. Re-exports `bootInBrowser` so the page's module script can call it.
 */

import { bootInBrowser } from './index.js';

export { bootInBrowser } from './index.js';

// Auto-boot when loaded directly into a page that already has the mount root and
// has not booted yet (idempotent: a second import is a no-op if already mounted).
const root = document.getElementById('harness-root');
if (root && root.childElementCount === 0) {
  try {
    const tier = root.dataset.isolationTier as 'STRONG' | 'BEST-EFFORT' | undefined;
    bootInBrowser({ mountPoint: '#harness-root', ...(tier ? { isolationTier: tier } : {}) });
  } catch (err) {
    const el = document.getElementById('boot-error');
    if (el) {
      el.style.display = 'block';
      el.textContent = `Boot error: ${String(err)}\n${err instanceof Error ? err.stack ?? '' : ''}`;
    }
  }
}
